import * as React from "react";
import { SectionCommon } from "./layout/section-common";
import styled from "@emotion/styled";
import JoinBG from "../svgs/join.svg";
import { PricingLink } from "./pricing-link";

const StyledJoin = styled.section`
  position: relative;
  height: 71.8rem;

  a {
    margin-top: var(--xx-small);
  }
`;

const BG = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(${JoinBG});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: -1;
`;

export const Join = ({ link }: { link?: { to: string; text: string } }) => (
  <StyledJoin>
    <SectionCommon
      title={
        <>
          Join many agencies.
          <br />
          Feel like our only client.
        </>
      }
    >
      <PricingLink to={link ? link.to : "/pricing"} className="btn-brand">
        {link ? link.text : " SEE PLANS & PRICING"}
      </PricingLink>
    </SectionCommon>
    <BG />
  </StyledJoin>
);
